import { RouteComponentProps } from '@reach/router';
import Page from 'components/shared/Page';
import React, { useState } from 'react';
import { endpoints } from '../../endpoints.config';
import { InfoTable } from 'components/infoTable/infoTable';
import { InvoicesMenuOptions } from './InvoicesMenuOptions';
import { InvoiceDropdownOptions } from './InvoiceDropdownOptions';

const dropdrownMenuOptions = (
  id: number,
  name: string,
  closeMenu: () => void,
  openCloseState: { open: boolean; id: number | null }
) => (
  <InvoiceDropdownOptions
    rowId={id}
    closeMenu={closeMenu}
    openCloseState={openCloseState}
    name={name}
  />
);

export const Invoices: React.FC<RouteComponentProps> = () => {
  const [isPanelClosed, setIsPanelClosed] = useState<boolean>(true);
  return (
    <Page>
      <div className="PageContent InvoicesPage WidthContent">
        <InfoTable
          title="Invoices"
          listUrl={endpoints.invoices.list}
          dropdrownMenuOptions={dropdrownMenuOptions}
          firstColWidth={215}
          firstColWidthSm={110}
          updateListStatus={true}
          setIsPanelClosed={setIsPanelClosed}
          isPanelClosed={isPanelClosed}
          allowSelectAll={false}
          filterTable={false}
        >
          <InvoicesMenuOptions />
        </InfoTable>
      </div>
    </Page>
  );
};
